/** Cross-links to the sibling products for the same ISIN.
 *
 * The three public webs (openvenue = instrument/market record,
 * isin-es = Spain view, security-passport = evidence per value)
 * link to each other by ISIN only — no schema or internal-URL
 * coupling (openvenue ADR-001). */
export function SiblingLinks({ isin }: { isin: string }) {
  const id = encodeURIComponent(isin);
  const cls =
    "underline underline-offset-2 hover:text-[var(--ink)]";
  return (
    <nav
      aria-label="Same ISIN on the sibling records"
      className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[var(--ink-2)]"
    >
      <span>Same ISIN on</span>
      <a
        href={`https://openvenue.h1756.es/#/i/${id}`}
        target="_blank"
        rel="noreferrer"
        className={cls}
        title="OpenVenue instrument and market record"
      >
        OpenVenue
      </a>
      <a
        href={`https://isin-es.h1756.es/isin/${id}`}
        target="_blank"
        rel="noreferrer"
        className={cls}
        title="isin-es Spain view"
      >
        isin-es
      </a>
    </nav>
  );
}
